Librarian.Modules.Workflow = new Class({
    Extends: Librarian.Modules.Module,
    Binds: ["loadData", "onItemClicked", "onButtonClicked"],

    options: {
        classPrefix: "modules-workflow-",
        orderBy: "ModifiedDate",
        order: "desc",
        count: 10,
        showAddButton: true,
        showHistory: true,
        showToDo: true,
        isMetro: false,
        isSquare: false,
        openWorkflow: false
    },

    listEl: null,

    initialize: function(options, wrapperEl) {
        this.setOptions(options);
        this.parent(this.options, wrapperEl);
    },

    destroy: function() {
        if (this.listEl) {
            $(this.listEl).destroy();
            this.listEl = null;
        }
    },

    load: function() {
        if (!this.wrapperEl)
            return;

        this.parent();

        if (this.options.showAddButton && !this.options.isMetro && !this.options.isSquare) {
            // Create the submit button
            new Element("input[type=button]", {
                "class": "button " + (this.options.classPrefix || '') + "button",
                "value": Librarian.Lang.getString("workflow_submit")
            }).injectInside(this.containerEl).addOnClick(this.onButtonClicked, this);
        }

        if (this.options.isMetro && !this.options.isSquare) {
            var label = (this.options.label || '').trim();
            if (label.length > 0) {
                new Element("div", {
                    "class": "nav-label",
                    "html": Librarian.Lang.getString(label),
                    "data-translation": label
                }).injectInside(this.containerEl);
            }
            this.containerEl.addOnClick(this.onButtonClicked, this);
        }

        // The list container
        this.listEl = new Element("ul").injectInside(this.containerEl);

        var showToDo = this.options.showToDo && Librarian.Utils.isUserMemberOfGroup(Librarian.workflow.groupNames);
        if (this.options.showHistory || showToDo && !this.options.isMetro) {
            // the footer container
            var footerEl = new Element("div", {
                "class": (this.options.classPrefix || '') + "footer"
            }).injectInside(this.wrapperEl);

            if (this.options.showHistory) {
                // the history link
                new Element("a", {
                    "text": "View History",
                    "class": "left"
                }).injectInside(footerEl).addOnClick(this.onHistoryClicked, this);
            }

            // and the "My To Do" list, but only if they are in the correct group
            if (showToDo) {
                new Element("a", {
                    "text": Librarian.Lang.getString("workflow_todo_mylist"),
                    "class": "right"
                }).injectInside(footerEl).addOnClick(this.onToDoClicked, this);
            }

            // Set the height of the container to compensate for the height of the footer
            var footerHeight = footerEl.getHeight(),
                contHeight = this.containerEl.getHeight() - footerHeight - 10;

            if (!isNaN(contHeight))
                this.containerEl.setStyle("height", contHeight + "px");
        }

        if(this.options.isSquare) {
            // add view all button
            new Element("span", {
                "class": "viewAll",
                events: {
                    click: this.onHistoryClicked 
                },
                text: Librarian.Lang.getString("homepage_viewall"),
                "data-translation": "homepage_viewall"
            }).injectInside(this.wrapperEl);
        }

        if (this.options.openWorkflow) {
            this.containerEl.addOnClick(Librarian.Utils.openWorkflowToDo, this);
        }
        else 
        this.loadData();
    },

    loadData: function() {
        if (!this.listEl)
            return;

        var url = Librarian.Workflow.getOpenUserInstancesURL(this.options.orderBy, this.options.order, 1) + "&perpage=" + this.options.count;

        this.listEl.empty();

        if (!this.options.isMetro || this.options.isSquare) {
            this.request = new Librarian.Request.JSON({
                url: url,
                onSuccess: function(json) {
                    if (!json || !json.data || (json.data.length == 0) || !this.listEl)
                        return;

                    var requests = json.data;
                    if (this.options.isSquare) {
                        requests.length = Math.min(requests.length, 8);
                    }
                    // Go through each request
                    for (var i = 0; i < requests.length; i++) {
                        // Build the elements
                        var request = requests[i],
                            listItemEl = new Element("li",
                            {
                                "class": (this.options.classPrefix || '') + "item"
                            }).injectInside(this.listEl),
                            requestLinkEl = new Element("a",
                            {
                                "class": (this.options.classPrefix || '') + "list",
                                "html": this.getDisplayName(request)
                            }).injectInside(listItemEl);

                        requestLinkEl.request = request;
                        requestLinkEl.onItemClicked = this.onItemClicked;
                        requestLinkEl.addOnClick(function() {
                                this.onItemClicked(this.request);
                            },
                            requestLinkEl);
                    }
                }.bind(this),
                onFailure: Librarian.Utils.onFailure
            });
            this.request.send();
        }
    },

    getDisplayName: function(data) {
        return data.processname;
    },

    onItemClicked: function(/*data*/) { return false; },
    onButtonClicked: function() { return false; },
    onHistoryClicked: function() { return false; },
    onToDoClicked: function() { return false; }
});